import { render, staticRenderFns } from "./ModalNoticeStorage.vue?vue&type=template&id=d60039ee&scoped=true&"
import script from "./ModalNoticeStorage.vue?vue&type=script&lang=js&"
export * from "./ModalNoticeStorage.vue?vue&type=script&lang=js&"
import style0 from "./ModalNoticeStorage.vue?vue&type=style&index=0&id=d60039ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60039ee",
  null
  
)

export default component.exports